<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" id="btnBack" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ $t('clinic.selectClinic') }}</h5>
    </div>
    <div class="offcanvas-body">
      <p>{{ $t('clinic.selectClinicChoose') }}</p>

      <div v-if="clinicList.items?.length > 0" class="align-items-center pagination-row">
        <p class="pagination-total">{{ `${clinicList.total} ${$t("pagination.clinics")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="clinicList.total" :is-loading="loading"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>

      <div class="no-results-box" v-if="alert.message">
        <BaseNoResults :title="alert.title" :text="alert.message"/>
      </div>

      <ul class="scrollbar" v-if="clinicList.items?.length > 0">
        <li v-for="(item, index) in clinicList.items" :key="index">
          <button class="btn btn-outline-secondary no-wrap" :class="{'active': session.currentClinic && session.currentClinic.id == item.id}" type="button" name="button" @click="doChange(item)">
            {{ item.name }}
            <span v-if="session.currentClinic && session.currentClinic.id == item.id"> ({{ $t('createClinic.currentClinic') }})</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas .offcanvas-body {
  display:                                flex;
  flex-direction:                         column;

  ul {
    flex:                                 1;
    max-height:                           unset;
  }
}

.scrollbar {
  .no-wrap {
    display:                               block;
  }
}

.pagination-row {
  margin-bottom:                           26px;
}

.pagination-total {
  margin-bottom:                           0 !important;
}

:deep(.pagination.justify-content-end) {
  flex-direction:                          row;

  .disabled:not(.page-item) {
    display:                               flex;
    align-items:                           center;
    gap:                                   5px;

    span {
      white-space:                         nowrap;
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'

export default {
  name: 'ClinicChangeOffcanvas',
  props: {
    offcanvas_id: String
  },
  data: () => ({
    loading: false,
    alert: {
      title: null,
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    title: null,
    text: null,
    offcanvas_clinic: null,
    clinicList: {
      items: [],
      total: 0
    },
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    hasDataLoaded: false,
  }),
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
  },
  methods: {
    show() {
      this.currentPage = 1;
      this.clinicList = {items: [], total: 0}

      const offcanvasElement = document.getElementById(this.offcanvas_id);
      this.offcanvas_clinic = new bootstrap.Offcanvas(offcanvasElement);
      this.offcanvas_clinic.show();

      if (this.offcanvas_clinic) {
        this.debounce()
      }


      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      let _self = this
      setTimeout(async _ => {
        await this.$router.push({name: 'app'})
      }, 300)

      document.getElementById('btnBack').click()

      this.offcanvas_clinic = null;
      this.$message.popup(this, 'operationSuccess', 'operationSuccess', 'success')
      //this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_clinic = null;
      this.resolvePromise(false)
    },

    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },

    debounce: _.debounce(function () {
      this.fetchData()
    }, 250, { 'maxWait': 150 }),

    async fetchData() {
      let params = {
        page: this.currentPage,
        currentClinicId: this.session.currentClinic.id,
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.getList(params);

        const items = response.result

        this.clinicList = {
          items,
          'total': response.totalCount
        }

        this.totalPages = Math.ceil(response.totalCount / this.perPage);

        if (response.result.length === 0) {
          this.clinicList = {items: [], total: 0};
          this.totalPages = 1
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_clinic_title', 'request_notfound_clinic_text')
        }

      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },

    async doChange(item) {
      let params = {
        id: item.id,
      }

      this.loading = true
      NProgress.start()
      try {

        const sessionInfo = await this.$clinicService.changeClinic(params);
        this.session = sessionInfo;
        this.session.examCurrentPage = 1
        this.$authService.sessionChanged(sessionInfo)

        this.doConfirm()

      } catch (err) {
        this.$message.popup(this, 'clinic.errorChangeClinic', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'clinic.errorChangeClinic', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
  }
}
</script>
